import "./Header.css";

import { Link, NavLink } from "react-router-dom";
import { useState } from "react";

const Header = () => {

  const [navBar, setNavBar] = useState(false);

  const navBarVerify = () => {
    if(navBar){
      setNavBar(false);
    }else{
      setNavBar(true);
    }
  }

  return (
    <header>
      <nav className="nav_first">
        <div className="logo_container">
          <a href="www.dian.ga">
            <img src="/img/logo_dipage.png" alt="logo do site" />
            <h1>DiDeveloper</h1>
          </a>
        </div>
        <div className="navigation_container">
          <Link style={{ textDecoration: "none" }} to="/values">
            <span className="values_span">Valores</span>
          </Link>
          <Link style={{ textDecoration: "none" }} to="/como_funciona">
            <span className="values_span">Como funciona</span>
          </Link>
          <Link style={{ textDecoration: "none" }} to="/redes">
            <span>Redes Sociais</span>
          </Link>
          <Link style={{ textDecoration: "none" }} to="/termos">
            <span>Termos e Sobre Nós</span>
          </Link>
        </div>
        <div className={!navBar ? "hambuguer_content" : "hambuguer_content_open"} onClick={() => navBarVerify()}>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div className={navBar ? "navigation_container_mob" : "hidden"}>
          <Link style={{ textDecoration: "none" }} onClick={() => navBarVerify()} to="/values">
            <span className="values_span">Valores</span>
          </Link>
          <Link style={{ textDecoration: "none" }} onClick={() => navBarVerify()} to="/como_funciona">
            <span className="values_span">Como funciona</span>
          </Link>
          <Link style={{ textDecoration: "none" }} onClick={() => navBarVerify()} to="/redes">
            <span>Redes Sociais</span>
          </Link>
          <Link style={{ textDecoration: "none" }} onClick={() => navBarVerify()} to="/termos">
            <span>Termos e Sobre Nós</span>
          </Link>
        </div>
      </nav>
      <nav className="nav_secundary">

      <NavLink
          style={({ isActive }) => ({
            textDecoration: "none",
            borderBottom: isActive && "2px solid black",
          })}
          to="/"
        >
          <p className="standard_link">
            <i className="bi bi-book-fill"></i>
            <span>&nbsp;Todos</span>
          </p>
        </NavLink>

        <NavLink
          style={({ isActive }) => ({
            textDecoration: "none",
            borderBottom: isActive && "2px solid black",
          })}
          to="/premium"
        >
          <p className="premium_link">
            <i className="bi bi-trophy-fill"></i>
            <span>&nbsp;Prêmios</span>
          </p>
        </NavLink>

        <NavLink
          style={({ isActive }) => ({
            textDecoration: "none",
            borderBottom: isActive && "2px solid black",
          })}
          to="/standard"
        >
          <p className="standard_link">
            <i className="bi bi-box-fill"></i>
            <span>&nbsp;Padrão</span>
          </p>
        </NavLink>
      </nav>
    </header>
  );
};

export default Header;
